import { z } from '@uturn/portal/zod';

const selectableShipmentRequirementSchema = z.object({
	id: z.number(),
	code: z.string().optional(),
	description: z.string(),
	disabled: z.boolean().optional(),
});

export type SelectableShipmentRequirement = z.infer<
	typeof selectableShipmentRequirementSchema
>;

export const isSelectableShipmentRequirement = (
	data: unknown,
): data is SelectableShipmentRequirement =>
	selectableShipmentRequirementSchema.safeParse(data).success;
